<!-- BACKGROUND-IMAGE -->
<div class="login-img">
  <!-- PAGE -->
  <div class="page">
    <div class="">
      <!-- Theme-Layout -->

      <!-- CONTAINER OPEN -->
      <div class="col col-login mx-auto mt-7">
        <div class="text-center">
          <a routerLink="/dashboard/home"
            ><img
              src="./assets/images/brand/logo.png"
              class="header-brand-img m-0"
              alt=""
          /></a>
        </div>
      </div>
      <div class="container-login100">
        <div class="loading-pass-reset" *ngIf="showLoader">
          <div class="dimmer active">
            <div class="lds-ring">
              <div></div>
            </div>
          </div>
        </div>
        <div class="wrap-login100 p-6 rounded-10">
          <form class="login100-form validate-form">
            <span class="login100-form-title"> Resetar senha </span>
            <div class="wrap-input100 validate-input input-group">
              <a
                href="javascript:void(0)"
                class="input-group-text bg-white text-muted"
              >
                <i class="mdi mdi-email" aria-hidden="true"></i>
              </a>
              <input
                type="text"
                class="form-control"
                placeholder="E-mail"
                autocomplete
                [(ngModel)]="username"
                name="username"
              />
            </div>
            <div class="form-group mt-2">
              <p *ngIf="message.length > 0" class="text-success">
                {{ message }}
              </p>
            </div>
            <div class="form-group">
              <button
                type="submit"
                class="btn btn-md btn-dark"
                routerLink="/auth/login"
              >
                VOLTAR
              </button>
              <button
                type="submit"
                class="btn btn-md btn-primary btn-reset"
                (click)="resetPassword()"
              >
                RESETAR
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- END PAGE -->
</div>
<!-- BACKGROUND-IMAGE CLOSED -->
